import * as React from "react";

import { ArrowLeft24Regular } from "@fluentui/react-icons";
import { useLocation, useNavigate } from "react-router-dom";

import { useStyles } from "./styles";
import ButtonComponent from "../../components/Button/Button";

export interface FooterProps {
  className?: string;
  showBackButton?: boolean;
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const { className, showBackButton = false } = props;
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackToAnalysis = () => {
    console.log(location);
    if (location.pathname === "/view-cases") {
      const state = location.state as {
        documentReferenceId?: string;
        returnToCitationIndex?: number;
      } | null;

      if (state?.documentReferenceId) {
        // Navigate back to certification report with scroll position
        navigate("/certification-report", {
          state: {
            documentReferenceId: state.documentReferenceId,
            scrollToCitationIndex: state.returnToCitationIndex,
          },
        });
      } else {
        navigate("/certification-report");
      }
    } else {
      navigate("/executive-summary");
    }
  };

  return (
    <footer
      className={`${styles.footer} ${showBackButton ? styles.footerLeft : ""} ${className || ""}`}
    >
      {showBackButton && (
        <ButtonComponent
          variant="primary"
          onClick={handleBackToAnalysis}
          size="small"
          icon={<ArrowLeft24Regular />}
        >
          {location.pathname === "/view-cases" && location.state?.documentReferenceId
            ? "Back to Certification"
            : "Back to Analysis"}
        </ButtonComponent>
      )}
    </footer>
  );
};

export default Footer;
